import numeral from 'numeral'
export const IVA = 0.16
export const round = number => (Math.round(number * 100) / 100)

export const getIva = amount => amount - getSubtotal(amount)
export const getSubtotal = amount => {
    const div = numeral(IVA).add(1)
    return numeral(amount).divide(div.value()).value()
}
